module.exports = __webpack_public_path__ + "img/指数.2d6d2692.png";